<template>
    <div>

        <Section title="文件位置">
            <div style="padding: 20px">src / views / Main / Modules / Scroll / Scroll1.vue</div>
        </Section>

        <Section title="滚动块1">
            <div style="padding: 20px">

                <Scroll style="min-height: 100px; max-height: 200px; padding: 10px">
                    <ul>
                        <li style="width: 50px; height: 50px; background-color: #CCCCCC; float: left; margin-right: 10px; margin-bottom: 10px;" v-for="i in 100"></li>
                    </ul>
                </Scroll>

            </div>
        </Section>

        <Section title="滚动块2">
            <div style="padding: 20px">

                <Scroll style="min-height: 100px; max-height: 200px; padding: 10px">
                    <ul>
                        <Tag type="border" style="margin-bottom: 10px; margin-right: 10px;" closable v-for="i in 100">标签{{ i }}</Tag>
                    </ul>
                </Scroll>

            </div>
        </Section>

    </div>
</template>

<script>

    import Scroll from '@/modules/Scroll'

    import { Tag } from 'iview'

    export default {
        name: "Scroll1",

        components: {
            Scroll,
            Tag
        }
    }
</script>

<style scoped>

</style>
